import { render, staticRenderFns } from "./UtxoNFTPayload.vue?vue&type=template&id=07f63e66&scoped=true&"
import script from "./UtxoNFTPayload.vue?vue&type=script&lang=ts&"
export * from "./UtxoNFTPayload.vue?vue&type=script&lang=ts&"
import style0 from "./UtxoNFTPayload.vue?vue&type=style&index=0&id=07f63e66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f63e66",
  null
  
)

export default component.exports